import createItemActions from 'src/app/redux/utils/createItemActions';
import rest from './rest';

export default {
  fetchConfig: createItemActions('CONFIG', rest.fetchConfig),
};
